export enum PaidLabel {
  Newbie = 'NEWBIE',
  Blocked = 'BLOCKED',
  Careful = 'CAREFUL',
  Top = 'TOP',
  Proven = 'PROVEN',
  Prerogative = 'PREROGATIVE',
  NoLabel = 'NO_LABEL',
  NoAssign = 'NO_ASSIGN',
}

export enum ExtraFieldType {
  Enum = 'enum',
  Radio = 'radio',
  String = 'string',
}

export enum TutorBillingAccountType {
  Phone = 'PHONE',
  Email = 'EMAIL',
  Text = 'TEXT',
}
